// extracted by mini-css-extract-plugin
module.exports = {"chatInput":"ChatInput_chatInput__FdqnT","input":"ChatInput_input__GiH5r"};